import React from "react";
import { FaTrash } from "react-icons/fa"; // Εισαγωγή του εικονιδίου καδού

function DeleteButton({ onClick }) {
  return (
    <button
      onClick={onClick}
      className="flex items-center justify-center p-2 bg-red-700 text-white rounded hover:bg-red-800 transition-colors"
    >
      <FaTrash/>
    </button>
  );
}

export default DeleteButton;